<template>
<div class="swaychat-modal swaychat-fadeInUp">
  <div class="swaychat-row">
    <div class="swaychat-modal-content">
      <button class="swaychat-modal-close swaychat-button-close" @click="cancel">×</button>
      <div class="swaychat-rate-wrapper">
        <div class="swaychat-rate">
          <div class="swaychat-rate-label">
            <h5><span>{{ getLang.how_did_we_do }}</span></h5></div>
          <ul>
            <li class="swaychat-rate-great" @click="setRate(2)" :class="{
              'swaychat-rate-selected': rate == 2
              }"><i class="swaychat-rate-icon"></i>{{ getLang.ratings[2].label }}</li>
            <li class="swaychat-rate-ok" @click="setRate(1)" :class="{
              'swaychat-rate-selected': rate == 1
              }"><i class="swaychat-rate-icon"></i>{{ getLang.ratings[1].label }}</li>
            <li class="swaychat-rate-notgood" @click="setRate(-1)" :class="{
              'swaychat-rate-selected': rate == -1
              }"><i class="swaychat-rate-icon"></i>{{ getLang.ratings[-1].label }}</li>
          </ul>
        </div>
      </div>
      <div class="swaychat-form swaychat-leave-comment">
        <form novalidate @submit.prevent="save">
          <textarea-form-component @submit="save" v-model="comment" :error="error" :label="getLang.leave_comment"></textarea-form-component>
          <div class="swaychat-columns-half swaychat-columns">
            <button-form-component primary="true" :label="getLang.submit"></button-form-component>
          </div>
          <div class="swaychat-columns-half swaychat-columns">
            <button-form-component type="button" outline="true" :label="getLang.cancel" @click="cancel"></button-form-component>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import {
  mapGetters
} from 'vuex'
import ButtonFormComponent from './input/ButtonFormComponent.vue'
import TextareaFormComponent from './input/TextareaFormComponent.vue'


export default {
  components: {
    ButtonFormComponent,
    TextareaFormComponent
  },
  data() {
    return {
      comment: '',
      error: false
    }
  },
  computed: {
    rate() {
      return this.getSession.rate
    },
    ...mapGetters([
      'getLang',
      'getSession'
    ])
  },
  methods: {
    save() {
      this.$store.dispatch('submitRate',{
        rate: this.rate,
        comment: this.comment
      })
    },
    setRate(rate) {
      if (this.getSession.rate == rate)
        rate = 0
      this.$store.dispatch('setRate', rate)
    },
    cancel() {
      this.$store.dispatch('cancelEnd')
    }
  }

}
</script>
